import { Component, OnInit } from "@angular/core";
import { GeneralService } from "../services/general.service";

@Component({
  selector: "app-referencement",
  templateUrl: "./referencement.component.html",
  styleUrls: ["./referencement.component.scss"],
})
export class ReferencementComponent implements OnInit {
  enregistrementTerminer = true;
  keyWords;
  description;
  constructor(public generalService: GeneralService) {}

  ngOnInit(): void {
    this.getReferencement();
    this.getCaracteristiques();
  }
  enregistrer() {
    this.enregistrementTerminer = false;
    this.generalService.getDS("ecKW", 1).subscribe(
      (data: any) => {
        data.ecKW[0].ecKW_Code = this.description;
        data.ecKW[0].ecKW_Label = this.keyWords;
        this.generalService.enregisterTable(data).subscribe(
          (resp) => {
            this.generalService.dialogSuccess("Enregistré avec succés .", true);
            this.enregistrementTerminer = true;
          },
          (e) => {
            this.generalService.dialogSuccess("Non enregistrer .", false);
            this.enregistrementTerminer = true;
          }
        );
      },
      (e) => {
        this.generalService.dialogSuccess("Une erreur se produite .", false);
        this.enregistrementTerminer = true;
      }
    );
  }
  getReferencement() {
    this.generalService.getDS("ecKW", 1).subscribe((ref: any) => {
      this.description = ref.ecKW[0].ecKW_Code;
      if (this.generalService.cuurentUser != "BIGDAR")
        this.keyWords = ref.ecKW[0].ecKW_Label;
      else
      this.updateNgModel(this.splitString(ref.ecKW[0].ecKW_Label));
    });
  }
  listNgModelInput = [];
  listngModelTextArea = [];
  listCategorie;
  getCaracteristiques() {
    this.generalService
      .rechercheTable(this.generalService.urlListeCategorie)
      .subscribe(
        (data) => {
          this.listCategorie = this.getListCatWithoutParent(data);
          this.listNgModelInput = [];
          this.listCategorie.forEach((element) => {
            this.listNgModelInput.push(element.categorie_Text);
          });
        },
        (e) => {
          this.enregistrementTerminer = true;
        }
      );
  }
  getListCatWithoutParent(listCategorie) {
    const tab = listCategorie?.filter(
      (cat) =>
        cat?.categorie_Text &&
        cat?.categorie_Statut == 1 &&
        (cat?.categorie_CodeP == null ||
          cat?.categorie_CodeP == 0 ||
          cat?.categorie_CodeP == "")
    );
    return this.sort(tab, "categorie_Order");
  }
  sort(tab, key) {
    return tab?.sort((a, b) => a[key] - b[key]);
  }
  updateNgModel(splitString: string[]) {
    this.listngModelTextArea = splitString;
  }
  splitString(input: string): string[] {
    if (!input) {
      return [];
    }
    return input.split(/\+\?/);
  }
  concateAlltextareaAndPost() {
    var allKeyword = "";
    this.listngModelTextArea.forEach((element, index) => {
      allKeyword = allKeyword + this.listngModelTextArea[index] + "+?";
    });
    this.enregistrementTerminer = false;
    this.generalService.getDS("ecKW", 1).subscribe(
      (data: any) => {
        data.ecKW[0].ecKW_Code = this.description;
        data.ecKW[0].ecKW_Label = allKeyword;
        this.generalService.enregisterTable(data).subscribe(
          (resp) => {
            this.generalService.dialogSuccess("Enregistré avec succés .", true);
            this.enregistrementTerminer = true;
          },
          (e) => {
            this.generalService.dialogSuccess("Non enregistrer .", false);
            this.enregistrementTerminer = true;
          }
        );
      },
      (e) => {
        this.generalService.dialogSuccess("Une erreur se produite .", false);
        this.enregistrementTerminer = true;
      }
    );
  }
}
